import {configureStore} from '@reduxjs/toolkit';
import { authSlice } from './auth';
import { companySlice } from './company/companySlice';
import { contributionSlice } from './contributions/contributionSlice';
import { divestmentClubSlice } from './divestmentClub/divestmentClubSlice';
import { divestmentLPSlice } from './divestmentLP/divestmentLPSlice';
import { eventSlice } from './event/eventSlice';
import { eventRegisteredSlice } from './eventRegistered/eventRegisteredSlice';
import { fundDistributionSlice } from './fundDistribution/fundDistributionSlice';
import { investmentSlice } from './investment/investmentSlice';
import { investmentFundsSlice } from './investmentFunds/investmentFundsSlice';
import { languageSlice } from './language/languageSlice';
import { layoutSlice } from './layoutDashboard/layoutSlice';
import { opportunitySlice } from './opportunity/opportunitySlice';
import { partnerSlice } from './partner/partnerSlice';
import { reservationSlice } from './reservation/reservationSlice';
import { startupSlice } from './startup/startupSlice';
import { startupValorationSlice } from './startupValoration/startupValorationSlice';
import { vehicleSlice } from './vehicle/vehicleSlice';

export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        language: languageSlice.reducer,
        layout: layoutSlice.reducer,
        partner: partnerSlice.reducer,
        company: companySlice.reducer,
        startup: startupSlice.reducer,
        vehicle: vehicleSlice.reducer,
        startupValoration: startupValorationSlice.reducer,
        opportunity: opportunitySlice.reducer,
        event: eventSlice.reducer,
        eventRegistered: eventRegisteredSlice.reducer,
        reservation: reservationSlice.reducer,
        investment: investmentSlice.reducer,
        investmentFunds: investmentFundsSlice.reducer,
        contribution: contributionSlice.reducer,
        fundDistribution: fundDistributionSlice.reducer,
        divestmentClub: divestmentClubSlice.reducer,
        divestmentLP: divestmentLPSlice.reducer,
    }
})